import history from 'routers/history';
import { PATH_AUTH } from 'routers/paths';
import { queryClient } from 'App';
import removeTokensFromLocalStorage from './removeTokensFromLocalStorage';

const logout = () => {
  queryClient.clear();
  removeTokensFromLocalStorage();
  history.replace(PATH_AUTH.root);
};

export default logout;
